<div class="order-edit-delivery">
  <form
    class="deliveryForm row edit"
    [formGroup]="deliveryForm"
  >
    <ng-container *ngIf="panelStatus.isEdit">
      <eps-text-input
        label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER"
        [labelWidth]="labelWidth"
        readonly
        [value]="flowDetail.etmOrderNumber"
        *ngIf="!panelStatus.isNew && flowDetail.etmOrderNumber"
      ></eps-text-input>

      <!-- TYPE : radiogroup -->
      <eps-radio-group
        formControlName="type"
        [options]="flowRegistrationTypes"
        [disabled]="busy"
        (ngModelChange)="flowTypeChanged()"
        label="FLOWS.DELIVERY.LABELS.FLOWTYPE"
        class="col-12"
        [labelWidth]="labelWidth"
        [readonly]="panelStatus.isReadonly.flowType"
        autoSelect
      ></eps-radio-group>

      <!-- FROM : select -->
      <eps-select
        [options]="froms"
        formControlName="from"
        (ngModelChange)="fromChanged()"
        label="ORDERS.DELIVERY.LABELS.FROM"
        [labelWidth]="labelWidth"
        [bindAsObject]="true"
        [readonly]="panelStatus.isReadonly.from"
        [showErrors]="true"
        autoSelect
      ></eps-select>

      <!-- TO : select -->
      <eps-select
        [options]="tos"
        formControlName="to"
        (ngModelChange)="toChanged()"
        label="ORDERS.DELIVERY.LABELS.TO"
        [labelWidth]="labelWidth"
        [bindAsObject]="true"
        [readonly]="panelStatus.isReadonly.to"
        [showErrors]="true"
        autoSelect
      ></eps-select>

      <!-- CLEARING : read only boolean -->
      <eps-checkbox
        formControlName="clearing"
        label="ORDERS.DELIVERY.LABELS.CLEARING"
        [labelWidth]="labelWidth"
        readonly
        [showErrors]="true"
        [useIconsInReadonly]="true"
        *ngIf="deliveryForm && (deliveryForm.value.clearing === false || deliveryForm.value.clearing === true)"
      ></eps-checkbox>

      <!-- WHOLESALER : select -->
      <eps-select
        [options]="wholesalers"
        formControlName="wholesaler"
        (ngModelChange)="checkWholeSalerAndSenderRef()"
        label="FLOWS.DELIVERY.LABELS.WHOLESALER"
        [labelWidth]="labelWidth"
        [bindAsObject]="true"
        [readonly]="panelStatus.isReadonly.wholesaler"
        [showErrors]="true"
        [errors]="wholesalerErrorObject"
        [required]="wholesalerRequired"
        [addEmptyOption]="!wholesalerRequired"
        *ngIf="wholesalers.length > 0"
        autoSelect
      ></eps-select>

      <!-- CUSTOMER REFERENCE NUMBER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.CUSTOMER_REFERENCE_NUMBER"
        [required]="poNumberMandatory"
        formControlName="customerReferenceNumber"
        [inlineSuffix]="poNumberMask"
        [readonly]="panelStatus.isReadonly.customerReferenceNumber"
        [maxLength]="35"
        [warnings]="receiverRefNrValidationWarningObject"
        [errors]="receiverRefNrValidationErrorObject"
      ></eps-text-input>

      <!-- SENDER REFERENCE NUMBER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.SENDER_REFERENCE"
        formControlName="senderReferenceNumber"
        [readonly]="panelStatus.isReadonly.senderReferenceNumber"
        (ngModelChange)="checkWholeSalerAndSenderRef()"
        [required]="senderRefIsRequired || wholesalerFilledIn"
        [warnings]="senderRefNrValidationWarningObject"
        [errors]="senderRefNrValidationErrorObject || senderRefEmptyErrorObject"
        [maxLength]="35"
      ></eps-text-input>


      <!-- TRANSPORTER : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.TRANSPORTER"
        formControlName="transporter"
        [maxLength]="10"
        [readonly]="panelStatus.isReadonly.transporter"
      ></eps-text-input>

      <!-- LICENCE PLATE : text -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.LICENCE_PLATE"
        formControlName="licensePlate"
        [maxLength]="15"
        [readonly]="panelStatus.isReadonly.licensePlate"
      ></eps-text-input>

      <!-- REMARKS : text-area -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="ORDERS.DELIVERY.LABELS.REMARKS"
        formControlName="remarks"
        [maxLength]="999"
        [readonly]="panelStatus.isReadonly.remarks"
      ></eps-text-input>

      <!-- REMARKS HANDSHAKER : text-area -->
      <eps-text-input
        [labelWidth]="labelWidth"
        label="FLOWS.DELIVERY.LABELS.REMARKS_HANDSHAKER"
        formControlName="remarksHandshaker"
        [maxLength]="999"
        *ngIf="flowDetail.handshaker"
      ></eps-text-input>
    </ng-container>

    <!--
  http://patorjk.com/software/taag/#p=display&c=c%2B%2B&f=Big&t=Read%20only%20version
    _____                _               _                            _
   |  __ \              | |             | |                          (_)
   | |__) |___  __ _  __| |   ___  _ __ | |_   _  __   _____ _ __ ___ _  ___  _ __
   |  _  // _ \/ _` |/ _` |  / _ \| '_ \| | | | | \ \ / / _ \ '__/ __| |/ _ \| '_ \
   | | \ \  __/ (_| | (_| | | (_) | | | | | |_| |  \ V /  __/ |  \__ \ | (_) | | | |
   |_|  \_\___|\__,_|\__,_|  \___/|_| |_|_|\__, |   \_/ \___|_|  |___/_|\___/|_| |_|
                                            __/ |
                                           |___/
  -->

    <!--Form displayed when detail is opend  -->
    <div
      class="deliveryForm row"
      [formGroup]="deliveryForm"
      *ngIf="!panelStatus.isEdit"
    >
      <eps-label-body
        label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER"
        [labelWidth]="labelWidth"
        *ngIf="!panelStatus.isNew && flowDetail.etmOrderNumber"
        readonly
        class="col-12"
      >
        {{ flowDetail.etmOrderNumber }}
      </eps-label-body>

      <eps-radio-group
        formControlName="type"
        [options]="definitions.flow.type"
        [disabled]="busy"
        (ngModelChange)="flowTypeChanged()"
        label="FLOWS.DELIVERY.LABELS.FLOWTYPE"
        class="col-12"
        readonly
        [labelWidth]="labelWidth"
      ></eps-radio-group>

      <!-- arrow header -->
      <div class="row no-padding">
        <ng-container>
          <div class="col-12 col-md-5 col-sm-6">
            <eps-label-body
              label="ORDERS.DELIVERY.LABELS.FROM"
              readonly
              [labelWidth]="labelWidth"
            >
              {{ flowDetail.deliveryMethod.from?.name }}
            </eps-label-body>
          </div>
          <div
            class="col-1 hidden-xs hidden-sm"
            *ngIf="resolutionOkForArrow"
          >
            <app-arrow
              class="myarrow"
              [width]="60"
            ></app-arrow>
          </div>
        </ng-container>
        <div class="col-12 col-sm-6">
          <eps-label-body
            label="ORDERS.DELIVERY.LABELS.TO"
            readonly
            [labelWidth]="labelWidth"
          >
            {{ flowDetail.deliveryMethod.to?.name }}
          </eps-label-body>
        </div>
      </div>
      <!--end of arrow header  -->

      <div class="hr"></div>

      <div class="two-columns-container">
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.COMMENTS"
          class="col-12 col-md-6"
        >
          {{ deliveryMethod?.remarks || ('ORDERS.DELIVERY.LABELS.NO_REMARKS' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.PLATE"
          class="col-12 col-md-6"
        >
          {{ deliveryMethod?.licensePlate || ('ORDERS.DELIVERY.LABELS.NO_LICENCE_PLATE' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.CLEARING"
          class="col-12 col-md-6"
        >
          <eps-checkbox
            formControlName="clearing"
            label="ORDERS.DELIVERY.LABELS.CLEARING"
            [labelWidth]="labelWidth"
            labelPosition="none"
            readonly
            [useIconsInReadonly]="true"
            [showErrors]="true"
            *ngIf="deliveryForm && (deliveryForm.value.clearing === false || deliveryForm.value.clearing === true)"
          ></eps-checkbox>
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER"
          class="col-12 col-md-6"
        >
          {{ flowDetail.salesOrderNumber }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="FLOWS.DELIVERY.LABELS.WHOLESALER"
          class="col-12 col-md-6"
          *ngIf="deliveryMethod.wholesaler && deliveryMethod.wholesaler.name && deliveryMethod.wholesaler.name !== '-'"
        >
          {{ deliveryMethod.wholesaler.name }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.TRANSPORTER"
          class="col-12 col-md-6"
        >
          {{ deliveryMethod?.transporter || ('ORDERS.DELIVERY.LABELS.NO_TRANSPORTER' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.RECEIVER_REF"
          class="col-12 col-md-6"
        >
          {{ deliveryMethod?.customerReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_RECEIVER_REF' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="FLOWS.DELIVERY.LABELS.ORIGINAL_RECEIVER_REF"
          class="col-12 col-md-6"
          *ngIf="!isCreateFlow"
        >
          {{ deliveryMethod?.originalReferenceNumber || ('FLOWS.DELIVERY.LABELS.NO_ORIGINAL_RECEIVER_REF' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="ORDERS.DELIVERY.LABELS.SENDER_REF"
          class="col-12 col-md-6"
        >
          {{ deliveryMethod?.senderReferenceNumber || ('ORDERS.DELIVERY.LABELS.NO_SENDER_REF' | translate) }}
        </eps-label-body>
        <eps-label-body
          readonly
          [labelWidth]="labelWidth"
          label="FLOWS.DELIVERY.LABELS.REMARKS_HANDSHAKER"
          class="col-12 col-md-6"
          *ngIf="!panelStatus.isNew"
        >
          {{ deliveryMethod?.remarksHandshaker || ('ORDERS.DELIVERY.LABELS.NO_REMARKS' | translate) }}
        </eps-label-body>
      </div>
    </div>

    <div
      *ngIf="panelStatus.isEdit"
      class="footer-block"
    >
      <div class="row empty">
        <div class="col-12 hr-thick"></div>
      </div>

      <div class="buttons">
        <eps-button
          type="link"
          *ngIf="panelStatus.isNew"
          (buttonClick)="cancelClicked.emit()"
          label="SHARED.BUTTONS.CANCEL"
        ></eps-button>
        <eps-button
          [disabled]="!deliveryForm.valid || (refNrValidationPending | async) === true || receiverRefNrValidationErrorObject !== null"
          [busy]="(refNrValidationPending | async) === true"
          (buttonClick)="nextClickedFn()"
          [label]="panelStatus.isNew ? 'FLOWS.DELIVERY.BUTTONS.NEXT' : 'SHARED.BUTTONS.SAVE'"
          submit
        ></eps-button>
      </div>
    </div>
  </form>
</div>
<!--{{getTo()?.frequency}}-->
